import React from "react"
import {FormattedMessage} from "react-intl";
import {Button} from "reactstrap";
import ContentShow from "../../content-editor/content-show";
import AttachmentsList from "../attachments-list";
import ContentUnitHeader from "../content-unit-header";
import BaseComponent from "../../base-component";

class Article extends BaseComponent {
    render() {
        const { assignment, markAsDone, readOnly } = this.props;
        const contentUnit = assignment.content_unit;

        return (
            <article>
                <ContentUnitHeader contentUnit={contentUnit}/>
                <div className='container'>
                    <ContentShow contentData={contentUnit.content}/>
                    <AttachmentsList contentUnit={contentUnit}/>
                    { !readOnly && assignment.state !== 'complete' &&
                    <div>
                        <hr/>
                        <Button onClick={markAsDone}><FormattedMessage id='app.actions.mark_as_done'/></Button>
                    </div>
                    }
                </div>
            </article>
        )
    };
}

export default Article;
